import React, { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../firebase.init";
import "./SignupScreen.css";
import { useSignInWithEmailAndPassword } from 'react-firebase-hooks/auth';

function SignupScreen() {
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const navigate = useNavigate();
  let location = useLocation();
  const [
    signInWithEmailAndPassword,
    user,
    loading,
    error,
  ] = useSignInWithEmailAndPassword(auth);
  const signIn = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    await signInWithEmailAndPassword(email, password);
  };
  

  let from = location.state?.from?.pathname || "/";
  // if (loading) {
  //   return <Loading></Loading>
  // }
  if (user) {
    navigate('/home');
  }

  return (
    <div className="loginScreen">
      <div className="loginScreen__background">
        <img
          className="loginScreen__logo"
          src="https://i.ibb.co/7bWX0YV/Acq.png"
          alt=""
        />
        <button onClick={() => navigate('/signin')} className="loginScreen__button">
          Sign In
        </button>
        <div className="loginScreen__gradient" />
      </div>
      <div className="loginScreen__body">
        <div className="signupScreen">
          <form>
            <h1>Sign In</h1>
            <input ref={emailRef} placeholder="Email" type="email" />
            <input ref={passwordRef} placeholder="Password" type="password" />
            <button type="submit" onClick={signIn}>
              Sign In
            </button>

            <h4>
              <span className="signupScreen__gray">New to 'ACQ'D TV? </span>
              <span className="signupScreen__link" onClick={() => navigate('/signup')}>
                Sign Up now.
              </span>
            </h4>
          </form>
        </div>
      </div>
    </div>

  );
}

export default SignupScreen;
